import React from 'react';
import { Container } from 'react-bootstrap';
import { COMPANY_NAME } from '../constants';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-5">
      <Container>
        <div className="text-center py-4">
          <p className="mb-0">
            &copy; {currentYear} <span className="text-gradient fw-bold">{COMPANY_NAME}</span>. All rights reserved.
          </p>
          <p className="mb-0 mt-2 small opacity-75">
            First SPPUR Training Center in Bali
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
